import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  ALL_TIME_GREATS_CATEGORIES,
  statsForCategory,
} from "../../constants/allTimeGreats";

const GreatsStatRail = ({ category, stat, onCategoryChange, onStatChange }) => {
  const stats = statsForCategory(category);

  return (
    <Box sx={{ mb: 4 }}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={category}
        onChange={(_, next) => {
          if (next) onCategoryChange(next);
        }}
        sx={{
          mb: 2,
          bgcolor: "background.paper",
          "& .MuiToggleButton-root": {
            borderColor: "divider",
            color: "text.secondary",
            fontWeight: 700,
            textTransform: "none",
            px: 2,
          },
          "& .Mui-selected": {
            color: "primary.contrastText",
            bgcolor: "primary.main",
            "&:hover": { bgcolor: "primary.dark" },
          },
        }}
      >
        {ALL_TIME_GREATS_CATEGORIES.map((option) => (
          <ToggleButton key={option.value} value={option.value}>
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          overflowX: "auto",
          pb: 0.5,
          mx: -0.5,
          px: 0.5,
        }}
      >
        {stats.map((option) => {
          const selected = option.key === stat;
          return (
            <Box
              key={option.key}
              component="button"
              type="button"
              onClick={() => onStatChange(option.key)}
              sx={{
                appearance: "none",
                border: 0,
                background: "transparent",
                color: selected ? "text.primary" : "text.secondary",
                fontWeight: selected ? 800 : 600,
                fontSize: "0.875rem",
                letterSpacing: "0.02em",
                px: 1.25,
                py: 0.75,
                cursor: "pointer",
                whiteSpace: "nowrap",
                borderBottom: "2px solid",
                borderColor: selected ? "text.primary" : "transparent",
                "&:hover": { color: "text.primary" },
              }}
            >
              {option.railLabel}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default GreatsStatRail;
